var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrcode-box"},[_c('div',{ref:"qr",staticClass:"qrcode"}),(_vm.caption !== null ? _vm.caption : _vm.text)?_c('div',{staticClass:"url"},[_vm._v(_vm._s(_vm.caption !== null ? _vm.caption : _vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }